import OtherList from '@/components/ProductCommon/OtherList';
import { EFGredientUp } from '@/components/UI/svg/ProductStatic';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { BannerModule, CardModule, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/smartgenerator/h5/');

const defaultStyle = {
    background: 'transparent',
    padding: '0',
    margin: '0 auto',
    border: 'none',
    borderRadius: '0',
};

export default function SmartGenerator({ cssStyle }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { t } = useLang('smartgenerator');
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const webpUrl = '/media/smartgenerator/h5/';
    const bannerData = [
        {
            bgImgs: ['smartGenerator_banner_h5.webp', 'smartGenerator_banner_h5.jpg'],
            title: t('smart_generator.title'),
            des: t('smart_generator.mobile_subtitle'),
        },
    ];
    const item = {
        title: '',
        alt: t('smart_generator.third_title'),
        synopsis: t('smart_generator.third_title'),
        desc: t('smart_generator.third_des'),
        img_url: ['smartGenerator1_h5.webp', 'smartGenerator1_h5.jpg'],
    };

    const item1 = {
        title: '',
        alt: 'smart_generator_recharge',
        synopsis: ['jp', 'cn'].includes(locale) ? t('smart_generator.four_title') : `${t('smart_generator.four_title')} ${t('smart_generator.four_subtitle')}`,
        desc: `${t('smart_generator.four_des')}`,
        img_url: ['smartGenerator2_h5.webp', 'smartGenerator2_h5.jpg'],
    };
    const item2 = {
        title: '',
        synopsis: t('smart_generator.five_title'),
        alt: t('smart_generator.five_title'),
        desc: t('smart_generator.five_des'),
        img_url: ['smartGenerator3_h5.webp', 'smartGenerator3_h5.jpg'],
    };
    const item3 = {
        title: '',
        synopsis: `${t('smart_generator.six_title')}</br>${t('smart_generator.six_subtitle')}`,
        alt: t('smart_generator.six_alt'),
        desc: t('smart_generator.six_des'),
        img_url: [`smartGenerator4_h5_${imgLocal}.webp`, `smartGenerator4_h5_${imgLocal}.jpg`],
    };
    const otherProduct = getDetaileMoreProducts(
        gloproductlist,
        ['product_ps_river_river_pro_720', 'product_ps_delta_delta_pro', 'product_ps_delta_max_smart_extra_battery'],
        '',
        '',
    );
    return (
        <div
            className={`${css.smartgenerator} SmartGeneratorModule`}
            style={{
                background: styles.background,
                padding: styles.padding,
                margin: styles.margin,
                border: styles.border,
                borderRadius: styles.borderRadius,
            }}
        >
            <div className="bannerModule1">
                <BannerModule
                    data={bannerData}
                    config={{
                        titleColor: '#fff',
                        desColor: '#fff',
                        theme: 'white',
                        desFontSize: locale === 'jp' ? 0.13 : 0.17,
                        webpUrl,
                    }}
                />
            </div>

            <div className="ytdd">
                <div className="section section1">
                    <h3 className="tit">{t('smart_generator.ytdd_sec1_tit')}</h3>
                    <p className="subtit">{t('smart_generator.ytdd_sec1_subtit')}</p>
                    <div className="bg-img">
                        <EFPic name={['section1_h5.webp', 'section1_h5.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                    </div>
                </div>
                <div className="section section2">
                    <div className="section sec2-sec1">
                        <h3 className="tit">{t('smart_generator.ytdd_sec2-sec1_tit')}</h3>
                        <p className="subtit">{t('smart_generator.ytdd_sec2-sec1_subtit')}</p>
                        <div className="bg-img">
                            <EFPic name={['sec2-sec1_h5.webp', 'sec2-sec1_h5.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                        </div>
                    </div>
                    <div className="section sec2-sec2">
                        <h3 className="tit">{t('smart_generator.ytdd_sec2-sec2_tit')}</h3>
                        <div className="bg-img">
                            <EFPic name={['sec2-sec2_h5.webp', 'sec2-sec2_h5.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                        </div>
                    </div>
                    <div className="section sec2-sec3">
                        <h3 className="tit">{t('smart_generator.ytdd_sec2-sec3_tit')}</h3>
                        <div className="bg-img">
                            <EFPic name={['sec2-sec3_h5.webp', 'sec2-sec3_h5.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                        </div>
                    </div>
                </div>
                <div className="section section3">
                    <h3 className="tit">{t('smart_generator.ytdd_sec3_tit')}</h3>
                    <p className="subtit">{t('smart_generator.ytdd_sec3_subtit')}</p>
                    <div className="bg-img">
                        <EFPic name={['section3_h5.webp', 'section3_h5.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                    </div>
                </div>
                <div className="section section4">
                    <div className="desc-wrapper">
                        <h3 className="tit">{t('smart_generator.ytdd_sec4_tit')}</h3>
                        <p className="subtit">{t('smart_generator.ytdd_sec4_subtit')}</p>
                    </div>
                    <div className="bg-img">
                        <EFPic name={['section4_h5.webp', 'section4_h5.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                    </div>
                </div>
            </div>
            <TextWithImage
                data={item}
                config={{
                    position: 'top',
                    descColor: '#919191',
                    gradient: true,
                    webpUrl,
                    gradientColor: 'linear-gradient(67deg,rgb(128,209,254) -3%,rgb(175,253,255) 55%,rgb(35,214,255) 107%)',
                }}
            />
            <LineSpace height={0.4} background="transparent" />
            <div className={css.compare}>
                <div className="compare-top">
                    <div className="compare-text">
                        +25<span>%</span>
                        <EFGredientUp
                            style={{
                                position: 'absolute',
                                top: '.25rem',
                                right: '.05rem',
                                fontSize: '.31rem',
                            }}
                        />
                    </div>
                    <div className="compare-desc">{t('smart_generator.four_charging_efficiency')}</div>
                </div>
                <div className="compare-bottom">
                    <div className="compare-progress-item">
                        <div className="progress-text">{t('smart_generator.four_smart_generator')}</div>
                        <div className="progress-bar bar1"></div>
                    </div>

                    <div className="compare-progress-item">
                        <div className="progress-text">{t('smart_generator.four_other_generators')}</div>
                        <div className="progress-bar bar2"></div>
                    </div>

                    <div className="compare-desc">{t('smart_generator.four_charging_des')}</div>
                </div>
            </div>
            <LineSpace height={1.5} background="transparent" />
            <TextWithImage
                data={item1}
                config={{
                    position: 'top',
                    descColor: '#919191',
                    synopsisColor: '#fff',
                    webpUrl,
                }}
            />
            <LineSpace height={1.2} background="transparent" />
            <TextWithImage
                data={item2}
                config={{
                    position: 'top',
                    synopsisColor: '#fff',
                    descColor: '#919191',
                    fullScreen: false,
                    descFontSize: locale === 'jp' ? 0.13 : 0.14,
                    webpUrl,
                }}
            />
            <LineSpace height={1.2} background="transparent" />
            <TextWithImage
                data={item3}
                config={{
                    position: 'top',
                    synopsisColor: '#fff',
                    descColor: '#919191',
                    fullScreen: false,
                    text: locale === 'sa' ? 'right' : 'left',
                    webpUrl,
                }}
            />
            <LineSpace height={1.2} background="transparent" />
            <div className="cardModule1">
                <CardModule
                    cssStyle={{ backColor: '#000', webpUrl }}
                    data={{
                        items: [
                            {
                                title: '',
                                desc: `${t('smart_generator.seven_left_gray_des')}<span style="color: #fff">${t(
                                    'smart_generator.seven_left_white_des',
                                )}</span>`,
                                url: ['smartGenerator5_h5.webp', 'smartGenerator5_h5.jpg'],
                                alt: 'smart_generator_hassle_to_maintain',
                            },
                            {
                                title: '',
                                desc: `<span style='color: #fff'>${t('smart_generator.seven_right_white_des')}</span>${t(
                                    'smart_generator.seven_right_gray_des',
                                )}`,
                                url: ['smartGenerator6_h5.webp', 'smartGenerator6_h5.jpg'],
                                alt: 'smart_generator_LCD_easy_to_check',
                            },
                        ],
                        textGuide: '',
                        textTitle: t('smart_generator.seven_title'),
                        textDesc: '',
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />
            <OtherList theme="black" data={otherProduct} />
        </div>
    );
}
